import React, { memo } from 'react';
import classNames from 'classnames/bind';
import style from "../styles.pcss";
import { MessageText } from "../../MessageText";
import { ChevronDownIcon } from "../../icons";
import { prepareCardNumber } from "../../utils/prepareCardNumber";
var cn = classNames.bind(style);
var DropdownToggle = /*#__PURE__*/memo(function (_ref) {
  var onClick = _ref.onClick,
    isOpen = _ref.isOpen,
    option = _ref.option,
    error = _ref.error,
    disabled = _ref.disabled,
    theme = _ref.theme,
    title = _ref.title,
    emptyValueText = _ref.emptyValueText,
    icon = _ref.icon,
    helpMessage = _ref.helpMessage;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("button", {
    className: cn('toggle', isOpen && 'open', error.isError && 'error', theme && "toggle--".concat(theme)),
    disabled: disabled,
    onClick: onClick,
    type: "button"
  }, /*#__PURE__*/React.createElement("div", {
    className: cn('option-wrapper')
  }, (option === null || option === void 0 ? void 0 : option.iconSrc) && /*#__PURE__*/React.createElement("div", {
    className: cn('picture')
  }, /*#__PURE__*/React.createElement("img", {
    alt: "",
    className: cn('img'),
    src: option.iconSrc
  })), !icon && (title || (option === null || option === void 0 ? void 0 : option.label) || emptyValueText) && /*#__PURE__*/React.createElement("div", {
    className: cn('label', {
      'label--secondary': theme === 'secondary',
      'label--multiple': !!(option !== null && option !== void 0 && option.cardNumber)
    })
  }, title || option.label || emptyValueText), (option === null || option === void 0 ? void 0 : option.cardNumber) && /*#__PURE__*/React.createElement("div", {
    className: cn('card')
  }, prepareCardNumber(option.cardNumber)), (option === null || option === void 0 ? void 0 : option.additionalInfo) && /*#__PURE__*/React.createElement("div", {
    className: cn('extra-node')
  }, option.additionalInfo), /*#__PURE__*/React.createElement("div", {
    className: cn('icon', {
      'icon--open': isOpen && !icon,
      'icon--secondary': !icon && theme === 'secondary',
      'icon--default': !icon
    })
  }, icon || /*#__PURE__*/React.createElement(ChevronDownIcon, {
    size: "s"
  })))), (error.isError || helpMessage) && /*#__PURE__*/React.createElement(MessageText, {
    errorMessage: error.message,
    helpMessage: helpMessage
  }));
});
export { DropdownToggle };